<template>
  <v-dialog
    persistent
    no-click-animation
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    width="100%"
    max-width="400px"
  >
    <v-card>
      <v-card-title class="text-body-1 font-weight-semibold"
        >Hello {{ formattedUsername }}</v-card-title
      >
      <v-divider />
      <v-card-text class="py-4"
        >You have some tasks that need your attention. What would you like to
        do?</v-card-text
      >
      <v-card-actions>
        <v-btn
          @click="
            dialog = false;
            $refs.actionItemsTaskList.open();
          "
          depressed
          color="primary"
          class="text-capitalize mr-3"
        >
          Let's get them done</v-btn
        >
        <v-dialog
          persistent
          no-click-animation
          v-model="confirmNoDialog"
          width="400"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" outlined class="text-capitalize"
              >Maybe Later</v-btn
            >
          </template>
          <v-card>
            <v-card-title class="text-body-1 font-weight-semibold"
              >Are you sure?</v-card-title
            >
            <v-divider />
            <v-card-text class="py-4">
              You are behind on some tasks, do you still want to put them off?
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="text-capitalize"
                depressed
                @click="
                  confirmNoDialog = false;
                  dialog = false;
                  $refs.actionItemsTaskList.open();
                "
              >
                No, I'll do them now
              </v-btn>
              <v-btn
                color="error"
                class="text-capitalize"
                depressed
                @click="closeConfirmationDialog()"
              >
                Yes, I'm sure
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
      <ActionItemsTaskList
        :actionItems="actionItems"
        @ignore="$emit('ignore', $event)"
        ref="actionItemsTaskList"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
import ActionItemsTaskList from '@/modules/shared/components/action-items/ActionItemsTaskList.vue';
import { ActionItemsService } from '@/modules/shared/services/action-items.service';

export default {
  mixins: [PageMixin],
  props: {
    actionItems: {
      type: [Array, Object],
      default: () => []
    }
  },

  components: { ActionItemsTaskList },
  data() {
    return {
      dialog: false,
      confirmNoDialog: false
    };
  },

  computed: {
    formattedUsername() {
      if (!this.user?.username) return '';
      return this.user.username
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$refs.actionItemsTaskList.close();
    },

    closeConfirmationDialog() {
      const s = new ActionItemsService();
      s.coolDownForOneHour();
      this.confirmNoDialog = false;
      this.dialog = false;
    }
  }
};
</script>
